const MEDIA_PLAN_GALLERY_ENDPOINTS = {
  MEDIA_PLAN: (brandId: string): string => `/brands/${brandId}/media_plans`,
  MEDIA_PLAN_DETAILS: (brandId: string, mediaPlanId: string): string =>
    `/brands/${brandId}/media_plans/${mediaPlanId}`,
  MEDIA_PLAN_PIXELS: (brandId: string): string =>
    `/brands/${brandId}/media_plans/pixels`
};

export default MEDIA_PLAN_GALLERY_ENDPOINTS;
